/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */

import { SerializableMap } from '@zcode/bizos'
import type { City, Neighborhood } from '@zcode/state-type'

export const getBedroomCounts = ({ _data: { bedroom_counts } }: City | Neighborhood) =>
  new SerializableMap(
    ([0, 1, 2, 3, 4] as const).reduce<
      Array<
        [
          key: Parameters<Parameters<Neighborhood['bedroomCounts']['forEach']>[0]>[1],
          value: Parameters<Parameters<Neighborhood['bedroomCounts']['forEach']>[0]>[0],
        ]
      >
    >((entries, key) => {
      const value = bedroom_counts[key]
      if (typeof value !== 'undefined') {
        entries.push([key, value])
      }
      return entries
    }, [])
  )
